import { Label, Stack } from 'office-ui-fabric-react';
import oneNotePageDetailManager, { NavigateToAssociatedPage, OneNoteManagerActionTypes } from '../../../backend/OneNote/OneNoteTranscriptionManager';
import { AppLayoutSettings } from '../../common/styles/common.styles';
import dispatcher from '../../dispatcher';
import * as React from 'react';
import {
  getHoverPopUpDisplayBackgroundStyles, getHoverPopUpDisplayStyles,
  getLabelStyles, getLabelContainerStyles, TextClick, TextCliping, TextFontStyle
} from './OneNotePageInfoBar.styles';

export interface OneNotePageInfoBarProps {
  type: 'OneNotePageInfoBarProps';
  marginLeft: string;
  marginRight: string;
}

interface KeyValueLabelProps {
  type: 'KeyValueLabelProps';
  keyString: string;
  valueString: string;
}

interface OneNotePageInfoState {
  showHoverWindow: boolean;
}

export class OneNotePageInfoBar extends React.PureComponent<OneNotePageInfoBarProps, OneNotePageInfoState> {

  private registeredToken: string = "";
  constructor(props: OneNotePageInfoBarProps) {
    super(props);

    this.state = {
      showHoverWindow: false
    };
  }

  public componentDidMount() {
    this.registeredToken = dispatcher.register(this.handleUpdate);

    // Page info refresh request to make sure latest info is shown to user on component mount.
    oneNotePageDetailManager.RefreshPageInfoRequest();
  }

  public handleUpdate = (action: Event): void => {
    switch (action.type) {
      case OneNoteManagerActionTypes.OneNoteAssociatedPageUpdate:
        this.forceUpdate();
        break;
    }
  }

  public componentWillUnmount() {
    dispatcher.unregister(this.registeredToken);
  }

  public render() {
    const { marginLeft, marginRight } = this.props;

    const handleOnHover = () => {

      // Page info refresh request to make sure latest info is shown to user on UI render or re-Render.
      oneNotePageDetailManager.RefreshPageInfoRequest();
      this.setState({ showHoverWindow: true });
    }

    return (
      <div className='OneNotePageInfoBar'>
        <Stack horizontal styles={getLabelContainerStyles('0px ' + marginRight + ' 10px ' + marginLeft)}>
          <Label styles={getLabelStyles(
            AppLayoutSettings.AppFontSize.mediumFontSizePx,
            AppLayoutSettings.getAppColorContainer().mediumLabelColor.value)} >
            {TranscriptionStrings.OneNotePageInfoBarDescription}</Label>
          <Label styles={getLabelStyles(
            AppLayoutSettings.AppFontSize.mediumFontSizePx,
            AppLayoutSettings.getAppColorContainer().linkColor.value,
            TextCliping.Ellipsis, TextFontStyle.Bold,
            TextClick.Required)}
            onMouseEnter={handleOnHover} onMouseLeave={() => this.setState({ showHoverWindow: false })} onClick={() => NavigateToAssociatedPage()}>
            {oneNotePageDetailManager.GetAssociatedPageName()}</Label>

        </Stack>
        {this.state.showHoverWindow ?
          <Stack horizontal styles={getHoverPopUpDisplayBackgroundStyles(marginLeft, marginRight)}>
            <Stack styles={getHoverPopUpDisplayStyles()}>
              <KeyValueLabel
                type={'KeyValueLabelProps'}
                keyString={TranscriptionStrings.NotebookTitle}
                valueString={oneNotePageDetailManager.GetAssociatedNoteBookName()} />
              <KeyValueLabel
                type={'KeyValueLabelProps'}
                keyString={TranscriptionStrings.SectionTitle}
                valueString={oneNotePageDetailManager.GetAssociatedSectionName()} />
              <KeyValueLabel
                type={'KeyValueLabelProps'}
                keyString={TranscriptionStrings.PageTitle}
                valueString={oneNotePageDetailManager.GetAssociatedPageName()} />
            </Stack>
          </Stack> : null}

      </div>
    );
  }
}

const KeyValueLabel: React.FunctionComponent<KeyValueLabelProps> = (props: KeyValueLabelProps): JSX.Element => {

  const { keyString, valueString } = props;
  return (
    <Stack horizontal styles={getLabelContainerStyles('0px 1px 0px 1px')}>
      <Label styles={getLabelStyles(
        AppLayoutSettings.AppFontSize.smallPlusFontSizePx,
        AppLayoutSettings.getAppColorContainer().mediumLabelColor.value,
        TextCliping.Not_Required, TextFontStyle.Bold)}>{keyString}</Label>
      <Label styles={getLabelStyles(
        AppLayoutSettings.AppFontSize.smallPlusFontSizePx,
        AppLayoutSettings.getAppColorContainer().mediumLabelColor.value,
        TextCliping.Not_Required, TextFontStyle.Bold)}>{"  :  "}</Label>
      <Label styles={getLabelStyles(
        AppLayoutSettings.AppFontSize.smallPlusFontSizePx,
        AppLayoutSettings.getAppColorContainer().mediumLabelColor.value,
        TextCliping.Break_word, TextFontStyle.Bold)}>{valueString}</Label>
    </Stack>
  );
}

export function getOneNotePageInfoBar(marginLeft: string = '0px', marginRight: string = '0px') {
  return (
    <OneNotePageInfoBar
      type={'OneNotePageInfoBarProps'}
      marginLeft={marginLeft}
      marginRight={marginRight} />
  )
}


